module.exports = __webpack_public_path__ + "img/UI_shouji_button_02_aead120c2.png";